import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const BLOG_URL = import.meta.env.VITE_BLOG_URL || 'https://blog.raisa.chat';

export default function BlogPostPage() {
    const { i18n } = useTranslation();
    const locale = i18n.language.split('-')[0] === 'ro' ? 'ro' : 'en';

    useEffect(() => {
        // Redirect to external blog
        window.location.href = `${BLOG_URL}/${locale}`;
    }, [locale]);

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '50vh',
            flexDirection: 'column',
            gap: '1rem'
        }}>
            <div className="loading-spinner" />
            <p>Redirecting to blog...</p>
        </div>
    );
}
